
/*! AOS.js v2.3.1 - (C) https://github.com/michalsnik/aos */

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),f=o(c),s=n(8),d=o(s),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x=document.all&&!window.atob,j={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},O=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,j),(0,b.default)(w,j.once),w},_=function(){w=(0,h.default)(),O()},S=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},z=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},A=function(e){return j=i(j,e),w=(0,h.default)(),z(j.disable)||x?S():(document.querySelector("body").setAttribute("data-aos-easing",j.easing),document.querySelector("body").setAttribute("data-aos-duration",j.duration),document.querySelector("body").setAttribute("data-aos-delay",j.delay),"DOMContentLoaded"===j.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?O(!0):"load"===j.startEvent?window.addEventListener(j.startEvent,function(){O(!0)}):document.addEventListener(j.startEvent,function(){O(!0)}),window.addEventListener("resize",(0,f.default)(O,j.debounceDelay,!0)),window.addEventListener("orientationchange",(0,f.default)(O,j.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,j.once)},j.throttleDelay)),j.disableMutationObserver||(0,d.default)("[data-aos]",_),w)};e.exports={init:A,refresh:O,refreshHard:_}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(s,t),_?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function s(){var e=O();return c(e)?d(e):void(h=setTimeout(s,a(e)))}function d(e){return h=void 0,z&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(s,t),o(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,k=0,_=!1,S=!1,z=!0;if("function"!=typeof e)throw new TypeError(f);return t=u(t)||0,i(n)&&(_=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,z="trailing"in n?!!n.trailing:z),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(f);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return s;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?s:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f="Expected a function",s=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(s,t),_?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function f(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function s(){var e=j();return f(e)?d(e):void(h=setTimeout(s,u(e)))}function d(e){return h=void 0,z&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=f(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(s,t),i(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,O=0,_=!1,S=!1,z=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(_=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,z="trailing"in n?!!n.trailing:z),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==s}function a(e){if("number"==typeof e)return e;if(r(e))return f;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?f:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",f=NaN,s="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e,t){var n=new r(o);a=t,n.observe(i.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function o(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes),o=t.concat(n).filter(function(e){return e.hasAttribute&&e.hasAttribute("data-aos")}).length;o&&a()})}Object.defineProperty(t,"__esModule",{value:!0});var i=window.document,r=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,a=function(){};t.default=n},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,f=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new f},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});
/*****Site JS*****/
$(function(){
  /**
   * Module to ajaxify all add to cart forms on the page.
   *
   * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
   * Dual licensed under the MIT and GPL licenses:
   * http://www.opensource.org/licenses/mit-license.php
   * http://www.gnu.org/licenses/gpl.html
   *
   */
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  Shopify.AjaxifyCart = (function($) {

    // Some configuration options.
    // I have separated what you will never need to change from what
    // you might change.

    var _config = {

      // What you might want to change
      addToCartBtnLabel:             'Add to cart',
      addedToCartBtnLabel:           'Added',
      addingToCartBtnLabel:          'Adding...',
      soldOutBtnLabel:               'Sold Out',
      howLongTillBtnReturnsToNormal: 2000, // in milliseconds.
      cartCountSelector:             '.header-cart-count',
      cartTotalSelector:             '#cart-price',
      // 'aboveForm' for top of add to cart form, 
      // 'belowForm' for below the add to cart form, and 
      // 'nextButton' for next to add to cart button.
      feedbackPosition:              'nextButton',

      // What you will never need to change
      addToCartBtnSelector:          '[type="submit"]',
      addToCartFormSelector:         'form[action="/cart/add"]',
      shopifyAjaxAddURL:             '/cart/add.js',
      shopifyAjaxCartURL:            '/cart.js'
    };

    // We need some feedback when adding an item to the cart.
    // Here it is.  
    var _showFeedback = function(success, html, $addToCartForm) {
      $('.ajaxified-cart-feedback').remove();
      var feedback = '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
      switch (_config.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
          break;   
      }
      // If you use animate.css
      // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
      $('.ajaxified-cart-feedback').slideDown();
    };
    var _setText = function($button, label) {
      if ($button.children().length) {
        $button.children().each(function() {
          if ($.trim($(this).text()) !== '') {
            $(this).text(label);
          }
        });
      }
      else {
        $button.val(label).text(label);
      }
    };
	  var _init = function() {   
		  $(document).ready(function() { 
        $(_config.addToCartFormSelector).not('.exclude-ajax').submit(function(e) {
          e.preventDefault();
          var $addToCartForm = $(this);
          var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
          var form_data = $addToCartForm.serialize();
          if($addToCartBtn.closest('.add-to-cart').attr('data-preorder') === 'true') {
            _config.addToCartBtnLabel = $addToCartBtn.val() || $addToCartBtn.text();
          }

          console.log(_config);

          var _machineProd = $('.cart-line-items__item[data-product-id="1739565432902"]');
          if(_machineProd.length > 0 && $('body').hasClass('template-product') && $('body').attr('data-product-data').indexOf('1739565432902') > -1){        
            $('.alreadyInCartMessage').remove();  
            $('<span class="alreadyInCartMessage">The Machine is already in cart. Only 1 per order is allowed.</span>').insertAfter('.product-form-add-to-cart');
            window.setTimeout(function(){
              $('.alreadyInCartMessage').remove();  
            }, 5000);
            location.href = '/checkout';
            return false;
          }

          if(form_data.indexOf('kit') > -1){
            var kit_id = new Date().getTime();
            form_data += '&properties[kitid]=' + kit_id;
          }          

          _setText($addToCartBtn, _config.addingToCartBtnLabel);
          $addToCartBtn.addClass('disabled').prop('disabled', true);
              // Add to cart.
            $.ajax({
              url: _config.shopifyAjaxAddURL,
              dataType: 'json',
              type: 'post',
              data: form_data,
              success: function(itemData) {
                
                if(itemData.product_id === 1739565432902){
                  if($('.addon-products input').attr('disabled') === undefined){
                  	$.ajax({
                      url: '/cart/add.js',
                      dataType: 'json',
                      type: 'post',
                      data: 'id=' + $('.addon-products input').val() + '&quantity=1',
                      success: function(result) {
                        // Re-enable add to cart button.
                      	_setText($addToCartBtn, _config.addedToCartBtnLabel);                    
                        window.setTimeout(function(){
                          $addToCartBtn.prop('disabled', false).removeClass('disabled');
                          _setText($addToCartBtn,_config.addToCartBtnLabel);
                        }, _config.howLongTillBtnReturnsToNormal);
                        location.href = '/checkout';		
                      }
                    });
                  }else{
                    // Re-enable add to cart button.
                    _setText($addToCartBtn, _config.addedToCartBtnLabel);                    
                    window.setTimeout(function(){
                      $addToCartBtn.prop('disabled', false).removeClass('disabled');
                      _setText($addToCartBtn,_config.addToCartBtnLabel);
                    }, _config.howLongTillBtnReturnsToNormal);
                  	location.href = '/checkout';
                  }                  
                }else{
                  // Re-enable add to cart button.
                  _setText($addToCartBtn, _config.addedToCartBtnLabel);                    
                  window.setTimeout(function(){
                    $addToCartBtn.prop('disabled', false).removeClass('disabled');
                    _setText($addToCartBtn,_config.addToCartBtnLabel);
                  }, _config.howLongTillBtnReturnsToNormal);
                  window.buildCart();
                  if($(window).width() > 767){
                    $('body').toggleClass('sidecart-open');          
                  }else{
                    $('.header-cart-link').addClass('not-empty');
                    $('body').toggleClass('sidecart-open');
                  }
                }                
                                   
              }, 
              error: function(XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                if (response.slice(0,4) === 'All ') {
                  _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                  $addToCartBtn.prop('disabled', false);
                  _setText($addToCartBtn, _config.soldOutBtnLabel);
                  $addToCartBtn.prop('disabled',true);
                }
                else {
                  _showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
                  $addToCartBtn.prop('disabled', false).removeClass('disabled');
                  _setText($addToCartBtn, _config.addToCartBtnLabel);
                }
              }
            });   
            return false;    
        });
      });
	  };
  return {
    init: function(params) {
        // Configuration
        params = params || {};
        // Merging with defaults.
        $.extend(_config, params);
        // Action
        $(function() {
          _init();
        });
    },    
    getConfig: function() {
      return _config;
    }
  }  
  })(jQuery);

	Shopify.AjaxifyCart.init();
  $('body').on('click', '.header-cart-link', function(e){
    if(!$('body').hasClass('template-cart')){
      e.preventDefault();
      $('body').toggleClass('sidecart-open');
    }    
  });
  $('body').on('click', '._cartClose, .cart-overlay', function(){
    $('body').removeClass('sidecart-open');
  });
  $('body').on('click', '._add', function(){
    var _varId = $(this).attr('data-item-id');
    var _qty = 1;
    // if($('.cart-line-items__item[data-product-id="1739565432902"]').length > 0){
    //   _qty = $('.cart-line-items__item[data-product-id="1739565432902"]').attr('data-qty');
    // }
    var data= 'id=' + _varId + '&quantity=' + _qty;
    var prodName = $(this).closest('.cart-line-items__item').find('h4').text().trim();
// 		ga('send', 'event', 'Sidecart - Live', 'Add - [Click]', prodName);
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: data,
      success: function(itemData) {
        if($('body').hasClass('template-cart')){
          location.reload();
        }else{
          window.buildCart();
        }        
      }
    });
  }); 
  $('body').on('click', '._remove', function(){
    var _varId = $(this).attr('data-item-key');
    var data= 'id=' + _varId + '&quantity=0';

    if($(this).closest('li').data('gpid')){
      updateItemsByGpid($(this).closest('li').data('gpid'), 0)
    }else{
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: data,
        success: function(itemData) {
          if(_varId == 17007722561606){
            $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                data: 'id=20035971776582&quantity=0',
                success: function(itemData) {                    
                  window.buildCart();
                }
              });
          }else{
            window.buildCart();
          }			
        }
      });
    }
  });

  $('body').on('click', '._icon-plus', function(){
    $('#db-sidecart').addClass('cart-loading');    
    var _thisQty = $(this).closest('.number-input-wrapper').find('input.cart-item-quantity-display');
    var _qty = parseInt(_thisQty.val()) + 1;
    var _varId = _thisQty.attr('data-item-key');
    var data= 'id=' + _varId + '&quantity=' + _qty;

    if($(this).closest('li').data('gpid')){
      updateItemsByGpid($(this).closest('li').data('gpid'), _qty)
    }else{
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: data,
        success: function(itemData) {
          if(_varId == 17007722561606){
            $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                data: 'id=20035971776582&quantity=' + _qty,
                success: function(itemData) {                    
                  window.buildCart();
                }
              });
          }else{
            window.buildCart();
          }			
        }
      });
    }
  });

  $('body').on('click', '._icon-minus', function(){
    $('#db-sidecart').addClass('cart-loading');
    var _thisQty = $(this).closest('.number-input-wrapper').find('input.cart-item-quantity-display');
    var _qty = parseInt(_thisQty.val()) - 1;
    var _varId = _thisQty.attr('data-item-key');
    var data= 'id=' + _varId + '&quantity=' + _qty;

    if($(this).closest('li').data('gpid')){
      updateItemsByGpid($(this).closest('li').data('gpid'), _qty)
    }else{
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: data,
        success: function(itemData) {
          if(_varId == 17007722561606){
            $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                data: 'id=20035971776582&quantity=' + _qty,
                success: function(itemData) {                    
                  window.buildCart();
                }
              });
          }else{
            window.buildCart();
          }			
        }
      });
    }    
  });

  // Remove Multiple Products based on gpid
  function updateItemsByGpid(gpid, qty){
    let items = $('li.cart-line-items__item[data-gpid="'+ gpid +'"]');
    let formdata = {updates: {}};
    items.each(function(){
      formdata.updates[$(this).data('item-key')] = qty;
    });
    console.log(formdata);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata)
    })
    .then(response => response.json())
    .then(items => {
      window.buildCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });    
  }
	
  //Kit actions
  $('body').on('click', '.kit_icon-plus', function(){
    $('#db-sidecart').addClass('cart-loading');    
    
    if($('body').hasClass('template-cart')){
      var _thisQty = $(this).closest('.number-input-wrapper').find('input.cart-item-quantity-display');
      var _qty = parseInt(_thisQty.val()) + 1;
      var _varId = $(this).closest('tr').attr('data-target-id');    
      var kitsArray = []; 
      $('tr[data-kitid=' + _varId + ']').each(function(){
      	kitsArray.push($(this).data('item-key'));
      });  
    }else{
      var _thisQty = $(this).closest('.number-input-wrapper').find('span.cart-item-quantity-display');
      var _qty = parseInt(_thisQty.text()) + 1;$
      var _varId = $(this).closest('li').attr('data-target-id');    
      var kitsArray = []; 
      $('li[data-kitid=' + _varId + ']').each(function(){
      	kitsArray.push($(this).data('item-key'));
      });  
    }
     
    kitUpdates(kitsArray, _qty);
  });

  $('body').on('click', '.kit_icon-minus', function(){
    $('#db-sidecart').addClass('cart-loading');    
    if($('body').hasClass('template-cart')){
      var _thisQty = $(this).closest('.number-input-wrapper').find('input.cart-item-quantity-display');
      var _qty = parseInt(_thisQty.val()) - 1;
      var _varId = $(this).closest('tr').attr('data-target-id');    
      var kitsArray = []; 
      $('tr[data-kitid=' + _varId + ']').each(function(){
      	kitsArray.push($(this).data('item-key'));
      });  
    }else{
      var _thisQty = $(this).closest('.number-input-wrapper').find('span.cart-item-quantity-display');
      var _qty = parseInt(_thisQty.text()) - 1;
      var _varId = $(this).closest('li').attr('data-target-id');    
      var kitsArray = []; 
      $('li[data-kitid=' + _varId + ']').each(function(){
      	kitsArray.push($(this).data('item-key'));
      }); 
    }  
    
    kitUpdates(kitsArray, _qty);
  });

  $('body').on('click', '.kit_remove', function(){
    $('#db-sidecart').addClass('cart-loading');    
    if($('body').hasClass('template-cart')){
      var _qty = 0;
      var _varId = $(this).closest('tr').attr('data-target-id');    
      var kitsArray = []; 
      $('tr[data-kitid=' + _varId + ']').each(function(){
      	kitsArray.push($(this).data('item-key'));
      });  
    }else{
      var _qty = 0;
      var _varId = $(this).closest('li').attr('data-target-id');    
      var kitsArray = []; 
      $('li[data-kitid=' + _varId + ']').each(function(){
      	kitsArray.push($(this).data('item-key'));
      });       
    }  
    kitUpdates(kitsArray, _qty);
  });

  function kitUpdates(kitsArray, _qty){
    var x = 0;
    kitUpdate(kitsArray[x]);
    
    function kitUpdate(key){
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: { quantity: _qty, id: key },
        success: function(itemData) {
          x++;
          if(x < kitsArray.length){            
            kitUpdate(kitsArray[x]);
          }else{
            if($('body').hasClass('template-cart')){
              location.reload();
            }else{
              window.buildCart();
            } 
          }	
        }
      });
    }
  }  
  
  $('body').on('submit','form.dbs-forms', function(e){
    e.preventDefault();
    var _this = $(this);
    var _button = _this.find('button');
    var _buttonText = _button.text();

    var _thisProdId = $(this).data('product-id');
    var _machineProd = $('.cart-line-items__item[data-product-id="1739565432902"]');
    
    if(_thisProdId === 1739565432902 && _machineProd.length > 0){     
      $('body').addClass('sidecart-open');  
      window.buildCart(); 
      return false;

      $('.alreadyInCartMessage').remove();  
      $(this).append('<span class="alreadyInCartMessage">The Machine is already in cart. Only 1 per order is allowed.</span>');
      window.setTimeout(function(){
        $('.alreadyInCartMessage').remove();  
      }, 5000);
      location.href = '/checkout';
      return false;
    }

    _button.text('Adding...');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $(this).serialize(),
      success: function(result) {
        
        _button.text(_buttonText);
        
        if(result.product_id === 1739565432902007){
          location.href = '/checkout';
        }else{
          if($(window).width() > 767){
            $('body').addClass('sidecart-open');   
          }else{
            $('.header-cart-link').addClass('not-empty');
            $('body').addClass('sidecart-open');
          }        
          window.buildCart();
        }			
      }
    });
  });
  $('body').on('submit','form.dbs-forms-v2', function(e){
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $(this).serialize(),
      success: function(result) {            
        window.buildCart();			
      }
    });
  });
  window.buildCart = function(){
    $('#db-sidecart').addClass('cart-loading');
    window.checkProductsCount();
    $.ajax({
      url: '/cart?view=sidebar',
      method: 'get',
      success: function(result){
        $('#db-sidecart').html(result);
        $('#db-sidecart').removeClass('cart-loading');  
        if(window.discountCode !== '' && window.discountCode !== undefined) {
          $('.cart-check-out').attr('href', `/checkout?discount=${window.discountCode}`);
          if($('.cart-line-items__item[data-product-id="1739565432902"]').length >0) {
            let total_price = parseFloat($('.sc-footer_pricing > div').text().replace('$', ''));
            $('.sc-footer_pricing > div').text('$' + (total_price - (window.additionalDiscount/100)).toFixed(2));
            $('.sc-footer p.affirm-as-low-as').attr('data-amount', (total_price - (window.additionalDiscount/100))*100);

            let machinePrice = parseFloat($('.cart-line-items__item[data-product-id="1739565432902"] ._price span').text().replace('$', ''));
            $('.cart-line-items__item[data-product-id="1739565432902"] ._price span').text('$' + (machinePrice - (window.additionalDiscount/100)));
            $('.cart-line-items__item[data-product-id="1739565432902"] ._price span').prepend('<s style="color: var(--color-orange);">$' + machinePrice + '</s> ');
          }   

          if($('.cart-line-items__item[data-product-id="6834803834951"]').length >0) {
            let total_price = parseFloat($('.sc-footer_pricing > div').text().replace('$', ''));
            $('.sc-footer_pricing > div').text('$' + (total_price - (window.additionalDiscount/100)).toFixed(2));
            $('.sc-footer p.affirm-as-low-as').attr('data-amount', (total_price - (window.additionalDiscount/100))*100);

            let machinePrice2 = parseFloat($('.cart-line-items__item[data-product-id="6834803834951"] ._price span').text().replace('$', ''));
            $('.cart-line-items__item[data-product-id="6834803834951"] ._price span').text('$' + (machinePrice2 - (window.additionalDiscount/100)));
            $('.cart-line-items__item[data-product-id="6834803834951"] ._price span').prepend('<s style="color: var(--color-orange);">$' + machinePrice2 + '</s> ');
          } 
        }
      },
      error: function(error){
          console.log(error);
      }
    });		
  } 
  
   
  var _productsCarousal = $('.products-carousal ul')
  _productsCarousal.on('init', function(){
    _productsCarousal.fadeIn();
  })
  _productsCarousal.slick({
    dots: false,
    arrows: true,
    infinite: true,
    cssEase: 'linear',
    autoplay: false,
    speed: 500,
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    responsive:[
      {
        breakpoint: 1024,
        settings:{
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings:{
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });  
  
  $('.product-tabs-header-item').on('click', function(){
  	var _this = $(this);
    var _thisContent = $(this).attr('data-tab');
    _this
      .addClass('active')
        .siblings()
          .removeClass('active');
    $('#' + _thisContent).show().siblings().hide();
  });

  //Accordions
  $(document).on('click', '.accordion li>h6', function(){
    var _this = $(this);
    var _thisLi = $(this).closest('li'); 
    var _thisSiblings = _thisLi.siblings(); 
    _thisSiblings.find('h6').removeClass('active');
    _thisSiblings.find('h6+div').slideUp();
    _this.toggleClass('active');    
    _this.next('div').slideToggle();
  });

  $('header').on('mouseover', function(){
    $('header').addClass('header-hover');
  }).on('mouseout', function(){
    $('header').removeClass('header-hover');
  });
  $('.header-navigation-list li.primary-list-item').on('mouseover', function(){
    $('header').addClass('nav-hover');
  }).on('mouseout', function(){
    $('header').removeClass('nav-hover');
  });
  
  $('.header-navigation-list li.has-dropdown a.primary-link').on('click', function(e){
    if($(window).width() < 767){
      e.preventDefault();
      var _this = $(this);
      var _parent = _this.closest('li');
      var _thisLink = _parent.find('a.primary-link');
      _parent.toggleClass('active');
      _parent.find('.secondary-list').slideToggle();
      _thisLink.attr('aria-expanded', (_thisLink.attr('aria-expanded') === "false" ? "true" : "false"));
    }    
  });
  $('header .icon-menu').on('click', function(){
  	$('body').toggleClass('menu-active');
  });
  $('header .icon-close, .nav-overlay').on('click', function(){
  	$('body').removeClass('menu-active');
  });
  
  $('body').on('click', '[data-video-id]', function(){    
    var vidId = $(this).attr('data-video-id');
    onYouTubeIframeAPIReady(vidId);
  });
  
  
  function onYouTubeIframeAPIReady(vidId) {    
    var player;
    var _videoPopupHTML = '<div class="video-popup"><span class="vd-overlay">&nbsp;</span><span class="close-vid">' + window.DB.cross + '</span><div><div id="ytPlayer"></div></div></div>';
    $('body').append(_videoPopupHTML);
    
    player = new YT.Player('ytPlayer', {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
        loop: 0,
        controls: 1,
        showinfo: 0,
        autohide: 1,
        modestbranding: 1,
        vq: 'hd720',
        rel: 0
      },
      videoId: vidId     
    });
    // player = new YT.Player('player', {
    //   playerVars: { 
    //     'autoplay': 1, 
    //     'controls': 0,
    //     'loop': 0,
    //     'showinfo': 0,
    //     'autohide': 1,
    //     'modestbranding': 1, 
    //     'enablejsapi': 1,
    //     'rel': 0
    //   },        
    //   videoId: vidId,        
    //   events: {
    //     'onReady': onPlayerReady,
    //     'onStateChange': onPlayerStateChange
    //   }
    // });
    $('.video-popup').addClass('active');            
  } 
  $('body').on('click', '.video-popup .vd-overlay, .close-vid', function(){
    $('.video-popup').remove();
  });
  
  
//   Scroll Events
  $(window).on('scroll', function(){
    if($(window).scrollTop() > $('header').height()){
      $('body, header').addClass('scrolled');
    }else{
      $('body, header').removeClass('scrolled');
    }
  }); 
  
//Policies Accordians
  $('.shopify-policy__body h4,.shopify-text-pages__body h4').on('click', function(){
  	var _this = $(this);
    $(this).toggleClass('active');
    $(this).next('div').slideToggle();
  });

  $('[data-target]').on('click', function(){
    $('body,html').animate({ scrollTop: $('[data-point="'+ $(this).data('target') +'"]').offset().top - 100 });
  });
  
  //Quick Shop
  $(document).on('click', '.product-grid-item button.quick-shop', function(e){
    e.preventDefault();
    var $this = $(this);
    var $prodHandle = $this.closest('div.form').data('href') ;
    var $innerWrapper = $this.closest('.inner-wrapper');
    var $collectionList = $this.closest('.collection-list');    
    if($collectionList.length > 0 || $(window).width() < 767){
      $innerWrapper = $('body');
    }    
    $innerWrapper.find('.quick-shop-container').remove();
    $innerWrapper.append('<div class="quick-shop-container"><p style="padding: 80px 0; text-align: center;">loading...</p></div>');
    if($collectionList.length <= 0){
      window.scrollTo({
        top: $innerWrapper.find('.quick-shop-container').offset().top - 100,
        left: 0,
        behavior: 'smooth'
      });
    }    
    $.ajax({
      url: $prodHandle + '?view=quick-view',
      success: function(res){
        $innerWrapper.find('.quick-shop-container').html(res);
        if($collectionList.length > 0){
          $innerWrapper.find('.quick-shop-container').find('.qs-gallery').addClass('arrows-peach');
        }
      }
    });
  });
  $(document).on('click', '[data-qs-close]', function(e){
    if($('body').hasClass('template-collection') || $(window).width() < 767){
      $('.quick-shop-container').remove();
      return;
    }
    var $this = $(this);
    var $targetOffset = $this.closest('.products-carousal').offset().top - 100;
    $this.closest('.quick-shop-container').remove();
    window.scrollTo({
      top: $targetOffset,
      left: 0,
      behavior: 'smooth'
    });
  });
  
  if(localStorage.getItem('siteDisclaimer') !== 'off'){
  	$('body').addClass('site-disclaimer-on');
  }
  $('.site-disclaimer .icon-cross').on('click', function(){
    localStorage.setItem('siteDisclaimer', 'off');
    $('body').removeClass('site-disclaimer-on');
  });

  function bodyOffset(){
    if($(window).width() < 767 || $('body').hasClass('template-cart')){
      $('body').css('padding-top', $('#shopify-section-general-header header').outerHeight());
    }else{
      $('body').css('padding-top', 0);
    }
  }

  bodyOffset();
  $(window).on('resize', function(){
    bodyOffset();
  })

  //I popup
  $('body').on('click', '.i-popup', function(){
    let target = $(this).attr('data-popup-id');
    $(target).fadeIn();
  });

  $('body').on('click', '.i-popup-container .close', function(){
    $(this).closest('.i-popup-container').fadeOut();
  });
  
  if($('.shopify-policy__body').length > 0){
    $('.shopify-policy__body div:empty').remove()
  }  
  
  // check if route is in cart and remove it
  var _routeProd = $('.cart-line-items__item[data-product-id="4625844633671"]');
  if(_routeProd.length > 0){    
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      type: 'post',
      data: 'id='+ _routeProd.find('a._remove').attr('data-item-id') +'&quantity=0',
      success: function(itemData) {    
        window.buildCart();
      }
    });
  }

  $(document).on('click', '.to-reviews', function(e){
    e.preventDefault();
  	window.scrollTo({top: $('.yotpo--reviews').offset().top,left: 0,behavior: 'smooth'});
  }); 
  $(document).on('click', '.to-purchase', function(e){
    e.preventDefault();
  	window.scrollTo({top: $('.banner-products-list .products--list, .lp__products-slider .lp__products-list, .lp-machine-module').offset().top - 80,left: 0,behavior: 'smooth'});
  });

  $(document).on('click', '.to-purchase-2', function(e){
    e.preventDefault();
    console.log($('.lp__products-slider .lp__products-list').offset().top - 80);
  	window.scrollTo({top: $('.lp__products-slider .lp__products-list').offset().top - 80,left: 0,behavior: 'smooth'});
  });

  // Adding class active to the current item mobile alternate nav
  $('header .alternating-mobile-nav li a').each(function(){
    let $this = $(this);
    if(location.href.indexOf($this.attr('href')) > -1){
      $this.addClass('active');
    }
  });
  
  function topPaddingCalc(){
    if($('#shopify-section-product__machine-header').length > 0){
      let $header = $('header');
      let $machineHeader = $('.product__machine-header');
      $machineHeader.css('top', $header.outerHeight());
      $('body').css('padding-top', $header.outerHeight() + $machineHeader.outerHeight());  

      if($(window).scrollTop() >= $('#shopify-section-product__machine-header').offset().top){
        $('body').addClass('sticky-sub-nav');
      }else{
        $('body').removeClass('sticky-sub-nav');
      }
      
    }        
  }

  topPaddingCalc();

  $(window).on('resize scroll', function(){
    topPaddingCalc();
  });  
  
  $('.navigation-container .app-download-buttons a').on('click', function(){
  	ga('send', 'event', 'APP LINKS - LIVE', 'NAV - [Click]', $(this).find('img').attr('alt'));
  });
  
  $('footer .app-download-buttons a').on('click', function(){
  	ga('send', 'event', 'APP LINKS - LIVE', 'FOOTER - [Click]', $(this).find('img').attr('alt'));
  });

  $('.app-info-section .app-download-buttons a').on('click', function(){
  	ga('send', 'event', 'APP LINKS - LIVE', 'APP SECTION HP - [Click]', $(this).find('img').attr('alt'));
  });
});

$(window).on('load', function(){
  if($('body').hasClass('page-workout')){
    if(location.search !== ''){
      var vidParam = location.search.split('?')[1].split('vid=')[1].split('&')[0];
      $('li[data-video-id="' + vidParam + '"]').eq(0).click();      
      // onYouTubeIframeAPIReady(vidParam);
    }
  } 
})

class CountdownTimer extends HTMLElement {
  constructor () {
    super();
    
    this.init(this.dataset.dateTime)
  }

  init(limit) {
    var countDownDate = new Date(limit).getTime();
    let that = this;

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
      if(days > 0) {
        hours += days*24
      }
      
      var days = (days>9)?days:''+days;
      var hours = (hours>9)?hours:'0'+hours;
      var minutes = (minutes>9)?minutes:'0'+minutes;
      var seconds =(seconds>9)?seconds:'0'+seconds;
      that.innerHTML = hours + "H : " + minutes + "M : " + seconds + "S";

      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        that.innerHTML = "";
      }
    }, 1000);
  }
}

customElements.define('countdown-timer', CountdownTimer);

const videos = document.querySelectorAll('.video__control');
if(videos.length > 0) {
  videos.forEach((el) => {
    el.addEventListener('click', function(){
      let video = el.closest('.media').querySelector('video');      
      video.muted = !video.muted;
      if(el.innerText.indexOf('on') >= 0) {
        el.innerHTML = 'sound off <img src="https://cdn.shopify.com/s/files/1/0064/6588/0134/files/sound-on.png?v=1671168486" loading="eager" width="24" height="24" />'
      } else {
        el.innerHTML = 'sound on <img src="https://cdn.shopify.com/s/files/1/0064/6588/0134/files/sound-off.png?v=1671168486" loading="eager" width="24" height="24" />'
      }
    })
  })
}

$(function(){
  $('.product__price-discount u').on('click', function() {
    if(window.outerWidth > 768) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Y7wEdy']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'RkXpUA']);
    }
  });  
})